import { BaseRepository } from '@wephone-core/model/repository/base_repository';
import { NumberLocationEntity } from '../entity/number_location';
import { HttpEngine } from '@wephone-core/service/http_engine';
import _ from 'lodash';

export class NumberLocationRepository extends BaseRepository {
  private URL_SA_LIST = 'list/:enterprise_id';
  private URL_SA_MAKE_AS_PRIMARY = 'make_as_primary/:enterprise_id';
  private URL_LIST = 'list';
  private URL_MAKE_AS_PRIMARY = 'make_as_primary';

  ENTITY_CLASS = NumberLocationEntity;
  protected URL_PREFIX = 'number-location';


  protected getURLAction(action: string): string {
    switch (action) {
      case 'LIST':
        return this.getUrlV2(this.URL_LIST);
      default:
        return super.getURLAction(action);
    }
  }

  protected getUrl(suffix): string {
    return this.getUrlV2(suffix);
  }

  async createAndSave(object_data?: any, extra_data?: any): Promise<NumberLocationEntity> {
    const obj = this.create(object_data);
    const ret = await this.save(obj, extra_data);

    return this.getObjectById(ret.id);
  }

  async findByEnterpriseId(enterpriseId: number): Promise<NumberLocationEntity[]> {
    const url = this.getUrlV2(this.URL_SA_LIST.replace(':enterprise_id', enterpriseId.toString()));
    const list = await HttpEngine.getInstance().get(url);

    const ret: NumberLocationEntity[] = [];
    for (const item of list) {
      ret.push(this.create(item, false) as NumberLocationEntity);
    }

    return ret;
  }

  async makeNumberLocationAsPrimary(item: NumberLocationEntity, enterpriseId?: number): Promise<void> {
    const urlMakePrimary: string = enterpriseId ? this.URL_SA_MAKE_AS_PRIMARY.replace(':enterprise_id', enterpriseId.toString()) : this.URL_MAKE_AS_PRIMARY;
    const url = this.getUrlV2(urlMakePrimary);

    await HttpEngine.getInstance().post(url, {
      number_location_id: item.id,
      enterprise_id: enterpriseId
    });
  }

  // protected getRemoteData(use_cache = true, filters?: any): Promise<NumberLocationEntity[]> {
  //   const url = this.getUrlV2(this.URL_LIST);
  //   if (use_cache && (this.object_list || []).length) {
  //     return Promise.resolve(this.object_list);
  //   }
  //   return HttpEngine.getInstance().get(url, {}).then((updatedList: any) => {
  //     const objectListData: NumberLocationEntity[] = [];
  //     for (const newObjData of updatedList) {
  //       const item = _.find(objectListData, { id: newObjData.id }) || null;
  //       if (item) {
  //         item.setObjectData(newObjData);
  //         continue;
  //       }
  //       // create new object
  //       const newObj = this.create() as NumberLocationEntity;
  //       newObj.setObjectData(newObjData, false);
  //       objectListData.push(newObj);
  //     }
  //     this.setDataAsReady();
  //     this.setObjectList(objectListData);
  //     return this.object_list;
  //   });
  // }
}
